export default __webpack_public_path__ + "static/media/servicetype_3d_192.52f31cc2.png";